import React from 'react';

import styled from 'styled-components';
import LocalStorageHelper from '../../../Utilities/Helpers/LocalStorageHelper';
import { Paper, Typography } from '@mui/material';
import { CustomDetailsHeaderInterface } from '../../../Models/Common/CustomViewsInterfaces';

const Container = styled(Paper) <{
    $isdarkmode: boolean;
    $isNoPadding: boolean;
}>`
    display: flex;
    justify-content: space-between;
    width: '-webkit-fill-available' !important;
    background: var(--cardBgPrimaryColor);
    box-shadow: none !important;
    border: 1px solid;
    border-radius: 5px 5px 0px 0px !important;
    // padding: 20px;
    padding: ${(props) => props.$isNoPadding ? '0px 20px' : '20px'} !important;
    align-items: center;
    
    .headerTitle {
        font-weight: 600;
        font-size: 16px;
    }

    .headerBtnsContainer {
        display: flex;
        justify-content: space-between;
        gap: 10px;

        align-items: center;

        .lastSyncDateTime {
            font-size: 12px;
            font-weight: 500;
            color: #878a99 !important;
            font-style: italic;
        }
    }
`;

const CustomDetailsHeader = (props: CustomDetailsHeaderInterface) => {
    return <Container $isNoPadding={props?.isNoPadding ?? false} sx={{borderColor: 'customBorder.main'}} {...{
        $isdarkmode: (LocalStorageHelper.isDarkMode() ? LocalStorageHelper.isDarkMode() : false),
    }}>
        {!props?.isNoPadding && !props?.isTitleNotText && <Typography color="primaryText" className="headerTitle">{props?.title ?? "--"}</Typography>}
        {(props?.isNoPadding || props?.isTitleNotText) && <>{props?.title ?? null}</>}
        {props?.actionButtons && <div className="headerBtnsContainer">
            {props.actionButtons}
        </div>}
    </Container>
}

export default CustomDetailsHeader;